import { Link, NavLink } from 'react-router-dom';
import SearchInput from '@/components/base/SearchInput';

const NAV_LINKS = [
  { label: '首页', to: '/' },
  { label: '剧情', to: '/category/drama' },
  { label: '短片', to: '/category/short' },
  { label: '专题', to: '/category/special' },
  { label: '关于', to: '/about' },
];

export default function Navbar() {
  return (
    <header className="sticky top-0 z-40 border-b border-background-200/80 bg-background-50/90 backdrop-blur">
      <div className="flex h-16 items-center gap-4 px-4 md:gap-8 md:px-8">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-movie-2-fill text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="text-base font-extrabold tracking-tight text-foreground-950">
              男同视频
            </span>
            <span className="hidden text-[10px] font-medium tracking-[0.2em] text-foreground-400 sm:block">
              GAY VIDEO
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-600 hover:bg-background-200/70 hover:text-foreground-900'
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden w-full max-w-xs md:block">
          <SearchInput />
        </div>

        <Link
          to="/search"
          aria-label="搜索"
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-full bg-background-100 text-foreground-600 md:hidden"
        >
          <i className="ri-search-line text-xl" />
        </Link>
      </div>
    </header>
  );
}